<template>
  <div style="margin-top: 20px">
    <Spinner :isLoading="isLoading" />
    <a ref="topSection" />

    <div
      v-if="isLoading == false && model && model.Data_obj && model.Data_obj.totalPremiumIncFees != null && model.Data_obj.totalPremiumIncFees !== ''"
      :style="'position: fixed;left: calc(50% + 330px);z-index:2000;top:4px;border: 2px solid green;color: #525f7f;background-color: white; border-radius: 10px; height: 50px;padding:11px 20px 10px 20px'">
      Estimated Premium: <span>{{ estimatedPremiumOverlayDisplay }}</span>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)">


        <!-- <base-header class="pb-6 bg-primary">
      <b-row class="align-items-center py-4">
        <b-col lg="6" cols="7">
          <h6 class="h2 text-white d-inline-block mb-0">PE LIVE</h6>
        </b-col>
      </b-row>
    </base-header> -->
        <div class="container-fluid mt--6" v-if="model != null && step == 'step1'">
          <!-- <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
        <form class="needs-validation" @submit.prevent="handleSubmit(firstFormSubmit)"> -->


          <b-card no-body class="mb-4 uBind" v-if="((mode == 'view' || mode == 'edit') &&
            model.Customer_policy_status == 'in_progress') ||
            model.Customer_policy_status ==
            'offer_sent_awaiting_information' ||
            model.Customer_policy_status == 'offer_accepted'
          ">
            <b-card-header>
              <h2 class="secondary-card-header">
                Quote Details
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="3">
                  <!-- <base-input name="Insured Name" label="Business Name" inputGroupClasses="uBind-input"
                  :rules="formRules.insuredName">
                  <el-select id="insuredDD" @blur="InsuredNameBlurred($event)" @visible-change="visibleChange($event)"
                    @keyup.native="setInsuredName($event)" @change="selectCustomer($event)" v-model="model.insuredName"
                    :disabled="fieldsDisabled.insuredName" :rules="formRules.insuredName" filterable
                    placeholder="Add or search previous customers" v-cancel-read-only>
                    <el-option class="style-dropdown" v-for="(option, index) in customerList" :key="index"
                      :label="option.Customer_insured_name + ' (' + option.Customer_contact_first_name + ' ' + option.Customer_contact_last_name + ')'"
                      :value="option.Customer_id">
                    </el-option>
                  </el-select>
                </base-input> -->

                  <base-input type="text" name="Quote" label="Quote Ref" v-model="model.Quote_Ref_No"
                    :disabled="fieldsDisabled.Quote_Ref_No" :rules="formRules.Quote_Ref_No"
                    inputGroupClasses="uBind-input" />

                </b-col>
                <b-col md="3">
                  <base-input type="date" name="Quote" label="Quote Date" v-model="model.quote_created_date" disabled
                    :rules="formRules.insuredName" inputGroupClasses="uBind-input" />

                </b-col>
                <b-col md="3">
                  <base-input name="Inception Date" type="date" label="Inception Date" :rules="formRules.policyStart"
                    disabled v-model="model.policyStart" />
                </b-col>

                <b-col md="3">
                  <base-input name="Expiry Date" type="date" disabled label="Expiry Date" :rules="formRules.expiryDate"
                    v-model="model.expiryDate" />
                </b-col>
              </b-row>


              <b-row>
                <b-col md="4">
                  <base-input
                    prepend-icon="fas fa-dollar-sign"
                    type="text"
                    inputmode="decimal"
                    :preserveCursor="true"
                    :selectOnFocus="true"
                    :value="model.Data_obj.totalSumInsured"
                    @input="onEquipmentValueInput"
                    name="Equipment Value"
                    label="Equipment Value"
                  />
                </b-col>
                <b-col md="4">
                  <!-- <base-input prepend-icon="fas fa-dollar-sign" readonly v-model="model.totalExcess" name="Excess"
                    label="Excess" /> -->
                  <base-input name="excesses" label="Excess">
                    <el-select id="excessDD" @change="quoteChanged()" v-model="model.totalExcess"
                      :disabled="excessOptions.length <= 1">
                      <el-option v-for="option in excessOptions" :key="option.value" :label="option.label"
                        :value="option.value">
                      </el-option>
                    </el-select>
                  </base-input>
                </b-col>
                <b-col md="4">
                  <base-input prepend-icon="fas fa-dollar-sign" readonly :value="totalPremiumIncFeesDisplay"
                    name="Total Insurance Premium" label="Total Insurance Premium (inc all fees and charges)" />
                </b-col>
              </b-row>

              <b-row v-if="quoteModified == true">
                <b-col md="12" style="text-align: center;">
                  <base-button @click="getQuote()" type="danger" class="mb-4 bg-danger">Get New
                    Premium</base-button>
                </b-col>
              </b-row>


              <!-- <b-row>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium" prepend-icon="fas fa-dollar-sign" readonly
                    name="Insurance Premium" label="Insurance Premium" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_gst" prepend-icon="fas fa-dollar-sign"
                    readonly name="Premium GST" label="Premium GST" />
                </b-col>
                <b-col md="4">
                  <base-input v-model="model.Customer_policy_insurance_premium_stamp_duty"
                    prepend-icon="fas fa-dollar-sign" readonly name="Stamp Duty" label="Stamp Duty" />
                </b-col>
                <b-col md="3">
                  <base-input v-model="model.Customer_policy_fee" prepend-icon="fas fa-dollar-sign" readonly
                    name="Policy Fee" label="Policy Fee" />
                </b-col> 
              </b-row> -->
              <!-- <b-row>
                <b-col md="12">
                  <h5 style="font-size: 11pt !important">Notes:</h5>
                  <div style="margin-bottom: 25px">
                    <ul style="font-size: 11px;margin-bottom: 5px;" v-for="(option, index) in quoteNotes" :key="index">
                      <li style="font-size: 11px;margin-bottom: 5px;">{{ option }}</li>
                    </ul>
                  </div>
                </b-col>
              </b-row> -->
              <!-- <div class="text-center" v-if="mode == 'view' &&
                model.Customer_policy_status == 'in_progress'
                ">
                <b-row align-v="center">
                  <b-col>
                    <base-button @click="emailOffer()" type="danger" class="mb-4 bg-danger">Send to Customer</base-button>
                  </b-col>
                </b-row>
              </div> -->
              <div class="text-center" v-if="model.Customer_policy_status ==
                'offer_sent_awaiting_information'
              ">
                <b-row align-v="center">
                  <b-col>
                    <base-button @click="emailOffer()" type="danger" class="mb-4 bg-danger">Resend Customer Insurance
                      Offer</base-button>
                  </b-col>
                </b-row>
              </div>
            </b-card-body>
          </b-card>




          <b-card no-body class="uBind">
            <b-card-header>
              <h2 class="secondary-card-header">
                Insured Details
              </h2>
            </b-card-header>

            <b-card-body>

              <b-row>
                <b-col md="6">
                  <!-- <base-input name="Insured Name" label="Business Name" inputGroupClasses="uBind-input"
                  :rules="formRules.insuredName">
                  <el-select id="insuredDD" @blur="InsuredNameBlurred($event)" @visible-change="visibleChange($event)"
                    @keyup.native="setInsuredName($event)" @change="selectCustomer($event)" v-model="model.insuredName"
                    :disabled="fieldsDisabled.insuredName" :rules="formRules.insuredName" filterable
                    placeholder="Add or search previous customers" v-cancel-read-only>
                    <el-option class="style-dropdown" v-for="(option, index) in customerList" :key="index"
                      :label="option.Customer_insured_name + ' (' + option.Customer_contact_first_name + ' ' + option.Customer_contact_last_name + ')'"
                      :value="option.Customer_id">
                    </el-option>
                  </el-select>
                </base-input> -->

                  <base-input type="text" name="Insured Name" label="Business Name"
                    v-model="model.Customer_insured_name" :disabled="fieldsDisabled.insuredName"
                    :rules="formRules.insuredName" inputGroupClasses="uBind-input" />

                </b-col>
                <b-col md="6"> </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <div>
                    <a class="abn-link" target="_blank" href="https://abr.business.gov.au/">Don't know the ABN?</a>
                  </div>
                  <base-input type="text" name="Insured ABN" label="Insured ABN" pattern="[0-9]{11}"
                    v-model="model.Customer_abn" :disabled="fieldsDisabled.insuredABN" :rules="formRules.insuredABN"
                    prependIcon="fas fa-certificate" inputGroupClasses="uBind-input" />
                </b-col>
                <b-col md="6">
                  <base-input label="Please describe the main Business activities"
                    placeholder="E.g. Excavation services" v-model="model.Customer_business_description"
                    :disabled="fieldsDisabled.businessDesc" inputGroupClasses="uBind-input" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" name="Contact First Name" label="Contact First Name"
                    :rules="formRules.contactFName" v-model="model.Customer_contact_first_name"
                    :disabled="fieldsDisabled.contactFName" placeholder="John" />
                </b-col>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" name="Contact Last Name" label="Contact Last Name"
                    :rules="formRules.contactLName" v-model="model.Customer_contact_last_name"
                    :disabled="fieldsDisabled.contactLName" placeholder="Smith" />
                </b-col>
              </b-row>
              <b-row>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" label="Contact Phone Number" name="Contact Phone Number"
                    :rules="formRules.contactPhone" v-model="model.Customer_contact_number"
                    :disabled="fieldsDisabled.contactPhone" />
                </b-col>
                <b-col md="6">
                  <base-input inputGroupClasses="uBind-input" name="Contact Email" label="Contact Email"
                    :rules="formRules.contactEmail" v-model="model.Customer_contact_email"
                    :disabled="fieldsDisabled.contactEmail" placeholder="john@example.com" />
                </b-col>
              </b-row>

            </b-card-body>

          </b-card>


          <b-card class="uBind">
            <b-row>
              <h2 class="secondary-card-header">
                Address Details
              </h2>
            </b-row>

            <b-row>
              <b-col md="12" class="mb-4 uBind-input">
                <label for="addrs_1" class="form-control-label">
                  Search Insured Address
                </label>
                <input autocomplete="new-password" style="cursor: text" @blur="clearAddressFields" class="form-control"
                  id="addrs_1" v-model="model.Customer_contact_street" :disabled="fieldsDisabled.insuredStreet"
                  :rules="formRules.insuredStreet" />
              </b-col>
            </b-row>

            <b-row>
              <b-col md="4">
                <base-input label="City" v-model="model.Customer_contact_city" :disabled="fieldsDisabled.insuredCity"
                  :rules="formRules.insuredCity" inputGroupClasses="uBind-input" />
              </b-col>
              <b-col md="4">
                <!-- <base-input label="State" v-model="model.insuredState" /> -->
                <base-input name="State" label="State" :rules="formRules.insuredState" inputGroupClasses="uBind-input">
                  <el-select v-model="model.Customer_state" :disabled="fieldsDisabled.insuredState">
                    <el-option v-for="option in states" :key="option.label" :label="option.label" :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="4">
                <base-input autocomplete="off" label="Postcode" type="number" v-model="model.Customer_postcode"
                  :disabled="fieldsDisabled.insuredPostcode" inputGroupClasses="uBind-input" />
              </b-col>
            </b-row>

          </b-card>

          <b-card class="uBind">
            <b-row>
              <h2 class="secondary-card-header">
                Description of Asset
              </h2>
            </b-row>


            <b-row style="margin-bottom: 10px;">
              <div class="infoText">It is important that the asset is described correctly on the insurance policy. If it
                is not declared correctly and or attachments are missing, you may not be insured correctly.</div>

              <div class="infoText">Please provide a description of the asset in the field below or upload a dealers
                quotation or invoice outlining a description of the asset. </div>

            </b-row>



            <b-row style="margin-bottom: 20px">
              <b-col md="6">
                <div class="example-btn">
                  <ul>
                    <li v-for="(file, index) in fileList" :key="uploaderKey + '_file_' + index">
                      <div style="display: inline-block">{{ file.name }}</div>
                      <div v-if="!file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                        Please wait...file processing
                      </div>
                      <div v-if="file.success" style="display: inline-block; font-weight: bold; padding-left: 10px">
                        Upload successful
                      </div>
                    </li>
                  </ul>
                  <div
                    style="display: block; font-weight: 600;font-size: 0.875rem; color: #525f7f; margin-bottom: 20px">
                    Please upload equipment invoice if available
                  </div>
                  <file-upload class="btn btn-primary btn-uploader" :custom-action="customAction"
                    extensions="gif,jpg,jpeg,png,webp,doc,docx,pdf,xls,xlsx,csv"
                    accept="image/png,image/gif,image/jpeg,image/webp,application/msword,application/pdf,application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,text/csv,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                    multiple v-model="fileList" @input-filter="inputFilter" @input-file="inputFile" :input-id="uploaderKey"
                    :ref="uploaderKey" active="true">
                    <i class="fa fa-plus"></i>
                    Select files
                  </file-upload>
                </div>

              </b-col>
            </b-row>

            


                        <b-row>

              <b-col md="12">
                <!-- <base-input typ inputGroupClasses="uBind-input" name="description_of_asset" label="Description of Asset"
                  v-model="model.security1_other" /> -->

                <div
                    style="display: block; font-weight: 600;font-size: 0.875rem; color: #525f7f; margin-bottom: 20px">
                    -- Or --
                  </div>
                <base-input ref="descriptionOfAsset" name="Description of Asset" label="Description of Asset"
                  inputGroupClasses="uBind-input">
                  <textarea v-model="model.descriptionOfAsset" class="form-control" rows="4"></textarea>
                </base-input>
              </b-col>
            </b-row>

            <b-row>
              <b-col md="6">

                <base-input name="Financier" label="Financier" rules="required">
                  <el-select id="financierDD" @change="readFinancier($event)" v-model="model.financier" filterable>
                    <el-option v-for="option in financiers" :key="option.label" :label="option.label"
                      :value="option.value">
                    </el-option>
                  </el-select>
                </base-input>
              </b-col>
              <b-col md="6">
                <base-input id="financierOther" v-bind:disabled="model.financier != 'Other'"
                  placeholder="Select 'Other' in dropdown to activate this field" name="Financier - Other"
                  label="Financier - Other" v-model="model.financierOther" />
              </b-col>
            </b-row>



            <div v-if="!(fileList.length > 0 || model.descriptionOfAsset)" class="invalid-feedback"
              style="display: block;">
              Please enter a description of the asset to be insured - or - upload a quote/invoice. </div>


            <div v-if="!model.financier" class="invalid-feedback" style="display: block;">
              Please select a Financier. </div>

            <div v-if="model.financier == 'Other' && (!model.financierOther || model.financierOther == '')"
              class="invalid-feedback" style="display: block;">
              Please enter a value for Financier / Other. </div>


          </b-card>


          <b-card class="uBind" v-if="model.Data_obj.totalSumInsured > 125000">
            <b-row>
              <h2 class="secondary-card-header">
                Security Questions
              </h2>
            </b-row>


            <b-row style="margin-bottom: 30px;">
              Only for items of sum insured $125K or higher
            </b-row>

            <b-row style="height: 120px">
              <b-col md="6">
                <!-- <base-input name="security1" label="Where is the insured asset stored overnight?"
                  inputGroupClasses="uBind-input">
                  <el-select v-model="model.security1">
                    <el-option label="On the street" value="On the street" />
                    <el-option label="Garage" value="Garage" />
                    <el-option label="Carport" value="Carport" />
                    <el-option label="Driveway of property" value="Driveway of property" />
                    <el-option label="Other" value="other" />
                  </el-select>
                </base-input> -->
                <label class="form-control-label"> Where is the insured asset stored overnight? </label>
                <VueMultiselectComponent v-model="selectedSecurity1" :options="security1options" />
                <!-- <div v-if="selectedSecurity1.length == 0" class="invalid-feedback" style="display: block;"> Please select
                  at least one item </div> -->
              </b-col>
              <b-col md="6" v-if="selectedSecurity1.includes('Other')">
                <base-input inputGroupClasses="uBind-input" name="security1_other" label="Other (please specify)"
                  v-model="security1_other" />
                <div v-if="!security1_other || security1_other == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div>
              </b-col>
            </b-row>



            <b-row style="height: 120px">
              <b-col md="6">
                <!-- <base-input name="security2"
                  label="What security mitigations measures are in place where the item is insured?"
                  inputGroupClasses="uBind-input">
                  <el-select v-model="model.security2">
                    <el-option label="Locked Shed" value="Locked Shed" />
                    <el-option label="Locked Trailer" value="Locked Trailer" />
                    <el-option label="Back to Base Alarm" value="Back to Base Alarm" />
                    <el-option label="24 hour tracking device" value="24 hour tracking device" />
                    <el-option label="Wheel lock nuts" value="Wheel lock nuts" />
                    <el-option label="Immoboliser" value="Immoboliser" />
                    <el-option label="Microdotting" value="Microdotting" />
                    <el-option label="Other" value="other" />
                  </el-select>
                </base-input> -->

                <label class="form-control-label"> What security mitigations measures are in place where the item is
                  insured? </label>
                <VueMultiselectComponent v-model="selectedSecurity2" :options="security2options" />

                <!-- <div v-if="selectedSecurity2.length == 0" class="invalid-feedback" style="display: block;"> Please select
                  at least one item </div> -->
              </b-col>
              <b-col md="6" v-if="selectedSecurity2.includes('Other')">
                <base-input inputGroupClasses="uBind-input" name="security2_other" label="Other (please specify)"
                  v-model="security2_other" />
                <div v-if="!security2_other || security2_other == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div>
              </b-col>
            </b-row>

            <b-row style="height: 120px">
              <b-col md="6">
                <base-input inputGroupClasses="uBind-input" name="security3"
                  label="How long will this asset be stored on job sites at any one time?" v-model="security3" />
                <!-- <div v-if="!security3 || security3 == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div> -->
              </b-col>

            </b-row>

            <b-row style="height: 120px">
              <b-col md="6">
                <!-- <base-input name="security4"
                  label="What security mitigation measures are in place whilst on the job site? Example, locked shed, locked trailer, secure compound."
                  inputGroupClasses="uBind-input">
                  <el-select v-model="model.security4">
                    <el-option label="Locked Shed" value="Locked Shed" />
                    <el-option label="Locked Trailer" value="Locked Trailer" />
                    <el-option label="Secure Compound" value="Secure Compound" />
                    <el-option label="Back to base alarm" value="Back to base alarm" />
                    <el-option label="24 hour tracking device" value="24 hour tracking device" />
                    <el-option label="Wheel lock nuts" value="Wheel lock nuts" />
                    <el-option label="Immoboliser" value="Immoboliser" />
                    <el-option label="Microdotting" value="Microdotting" />
                    <el-option label="Other" value="other" />
                  </el-select>
                </base-input> -->

                <label class="form-control-label"> What security mitigation measures are in place whilst on the job
                  site?
                </label>
                <VueMultiselectComponent v-model="selectedSecurity4" :options="security4options" />
                <!-- <div v-if="selectedSecurity4.length == 0" class="invalid-feedback" style="display: block;"> Please select
                  at least one item </div> -->
              </b-col>
              <b-col md="6" v-if="selectedSecurity4.includes('Other')">
                <base-input inputGroupClasses="uBind-input" name="security4_other" label="Other (please specify)"
                  v-model="security4_other" />
                <div v-if="!security4_other || security4_other == ''" class="invalid-feedback" style="display: block;">
                  This field is required </div>
              </b-col>
            </b-row>

          </b-card>

          <b-card class="uBind">
            <b-row>
              <b-col md="12" style="margin-bottom: 20px;margin-top:0px; text-align: center;">
                <div style="max-width: 600px; margin: auto; margin-bottom: 20px" class="infoText">Please confirm all the
                  details above are correct and click button below.</div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" style="text-align: center;">

                <base-button v-bind:disabled="!isPage1FormValid()" @click="confirm()" type="danger"
                  class="mb-4 bg-danger">Proceed to Disclosure Section</base-button>
              </b-col>
            </b-row>
          </b-card>

          <!-- <div class="text-center">
            <b-row align-v="center" v-if="formMode == 'create'">
              <b-col>
                <base-button :disabled="!isFormValid" @click="createNewQuote()" type="danger" class="mb-4 bg-danger">Get
                  Premium</base-button>
              </b-col>
            </b-row>
            <div v-if="model.Customer_policy_status == 'in_progress' ||
              brokerObj.Broker_super_admin
              ">
              <b-row align-v="center" v-if="formMode == 'view'">
                <b-col>
                  <base-button @click="editQuote()" type="danger" class="mb-4 bg-danger">Edit Quote</base-button>
                </b-col>
              </b-row>

              <b-row align-v="center" v-if="formMode == 'edit'">
                <b-col>
                  <base-button @click="updateQuote()" type="danger" class="mb-4 bg-danger">Update Quote</base-button>
                </b-col>
              </b-row>
            </div>
          </div> -->

          <a ref="calcSection" />


        </div>
        <div class="container-fluid mt--6" style="margin-top: -7.5rem !important"
          v-if="model != null && step == 'step2'">

          <base-button @click="goBack()" type="uBind" class="mt-2 mt-sm-0 mb-4" style="width:150px"><i
              class="fas fa-angle-left pr-3"></i>Back</base-button>

          <b-card no-body class="mb-4 uBind">



            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                In Order to Finalise The Quotation Please Complete the Following Declaration
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="12">



                  <div class="infoText">This insurance quotation is provided to you by Insurance Advisernet Australia
                    AFSL
                    NO:
                    240549.</div>

                  <div class="infoText">Insurance Advisernet Australia is an insurance brokerage that has partnered with
                    your
                    finance broker to help you with an insurance quotation for your unregistered plant and equipment.
                  </div>

                  <div class="infoText">For full details of the Insurance Advisernet office providing this quotation
                    click
                    here: (<a target="_blank" style="color: #cc1a1a;text-decoration: underline;"
                      href="https://insuranceadviser.net/risk-advisory-australia-pty-ltd">https://insuranceadviser.net/risk-advisory-australia-pty-ltd</a>)
                  </div>


                </b-col>
              </b-row>

            </b-card-body>
          </b-card>
          <b-card no-body class="mb-4 uBind">
            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Your Duty of Disclosure
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>

                <div class="infoText">According to the Insurance Contracts Act 1984 (ICA), you and everyone who is
                  insured
                  under your policy must comply with a relevant duty.</div>

                <div class="infoText">Your duty to us means no misrepresentation. It's important that you read and
                  understand
                  your duty and answer all our questions truthfully and accurately.</div>


              </b-row>

              <b-row style="margin-top: 25px">


                <div class="infoText">The insurance is provided by Chubb Insurance Australia Limited, please download
                  Target
                  Market Determination, at <a style="color: #cc1a1a;text-decoration: underline;" target="_blank"
                    href="https://www.protecsure.com.au/tmd/">this
                    link</a>. </div>

                <div class="infoText">Target Market Determination (TMD) is designed to assist customers, distributors
                  and
                  Chubb Insurance Australia Limited (Chubb) staff to understand who this product has been designed for
                  and
                  who
                  it is not suitable for. </div>

                <!-- <div class="infoText">By getting a quote with us you agree that the right <a target="_blank"
                    style="color: #cc1a1a;text-decoration: underline;" href="/downloads/protecsure-pds.pdf">PDS</a> is
                  made
                  available to you on this site. </div> -->



              </b-row>
              <b-row>
                <div class="infoText">Please see <a target="_blank" style="color: #cc1a1a;text-decoration: underline;"
                    href="/downloads/financial-services-guide-and-privacy-collection-notice.pdf">FSG and privacy
                    collection
                    notice</a> and <a target="_blank" style="color: #cc1a1a;text-decoration: underline;"
                    href="/downloads/your-duty.pdf">Duty of Disclosure</a>. </div>
              </b-row>
            </b-card-body>
          </b-card>
          <b-card no-body class="mb-4 uBind">
            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Important Privacy Notice and General Questions
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="12" class="infoText">
                  We value your privacy. Our Privacy Policy sets out how we collect, disclose and handle personal
                  information
                  under the Privacy Act and the Australian Privacy principals. By providing us such information you
                  consent to
                  these practices unless you tell us otherwise. Our Privacy Policy is available at <a target="_blank"
                    href="https://www.insuranceadviser.net">www.insuranceadviser.net</a> or
                  by contacting us.
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  I/We consent to Insurance Advisenet's Privacy Policy and acknowledge our Duty of Disclosure under the
                  Insurance
                  Contracts Act 1984 (as amended), to disclose to the Insurer every matter that I/We may know, or
                  could reasonably be expected to know, that is relevant to the Insurer's decision whether to
                  accept the risk of the insurance and, if so, on what terms. Failure to comply with the above may
                  result in the cancellation of the policy or a claim being declined or reduced.
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice1">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice1">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>




              <b-row>

                <b-col md="10" class="answerText">
                  Registered for GST?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="RegisteredForGst">
                    <base-switch :disabled="false" on-text="Yes" off-text="No"
                      v-model="model.Quote_data.registeredForGst">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>


              <b-row>

                <b-col md="10" class="answerText">
                  Any equipment claims or uninsured losses in the last 3 years?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="PastClaims">
                    <base-switch :disabled="false" on-text="Yes" off-text="No"
                      v-model="model.Quote_data.customFields.claims3Years">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>


              <b-row>

                <b-col md="10" class="answerText">
                  Are there any of the items you are quoting worth more than $50,000 each?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="MoreThan50k">
                    <base-switch :disabled="false" on-text="Yes" off-text="No"
                      v-model="model.Quote_data.customFields.anyExpensiveItems">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

              <b-row>

                <b-col md="10" class="answerText">
                  Is Chubb the current underwriter for these risks?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="MoreThan50k">
                    <base-switch :disabled="false" on-text="Yes" off-text="No"
                      v-model="model.Quote_data.customFields.isChubbCurrentlyUnderWriting">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>





              <b-row>

                <b-col md="10" class="answerText">
                  In the past 3 years have you had any insurance declined, cancelled, proposal or application
                  rejected, renewal refused, had any claim rejected, had any special term, condition, warranty or
                  excesses imposed by an Insurer?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice2">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice2">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>
              <b-row>

                <b-col md="10" class="answerText">
                  In the past 3 years have you or any Partner or other Director been declared bankrupt, been placed
                  into receivership or liquidation or been involved in any Company or Business that became insolvent
                  or entered administration or receivership or had any threats to life or property (whether private or
                  business)?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice3">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice3">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>
              <b-row>

                <b-col md="10" class="answerText">
                  In the past 10 years have you or any other Partner, Director or Owner been charged with or
                  convicted of any criminal offence, (other than minor traffic convictions) in connection to crimes
                  related to drugs, dishonesty, arson, theft, fraud or violence against persons or property, had
                  penalties imposed or been liable for any civil offence or pecuniary penalty exceeding $5,000?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice4">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice4">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>
              <b-row>

                <b-col md="10" class="answerText">
                  In the past 3 years have you lodged any claims, notified an Insurer of a potential claim, had any
                  claims made against you or aware of any incident that may give rise to a claim?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice5">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice5">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>
              <b-row>

                <b-col md="10" class="answerText">
                  Do you authorise us to give to, or obtain from, other Insurer’s or any relevant Third Party, in
                  accordance with our Privacy Policy, any information relating to insurance or claim information
                  held by you or any Insured Persons, Office Holders, Directors, Businesses or Corporations?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice6">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice6">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>
              <b-row>

                <b-col md="10" class="answerText">
                  Are you aware of any matter, or any exceptional circumstance not covered above, that relates to
                  the risk to be insured that you have not already told us about, and that you know or should know
                  may affect the Insurer’s decision to insure you?
                </b-col>

                <b-col md="2" style="text-align: right;">
                  <base-input name="privacyNotice7">
                    <base-switch on-text="Yes" off-text="No" v-model="model.privacyNotice7">
                    </base-switch>
                  </base-input>
                </b-col>
              </b-row>

            </b-card-body>
          </b-card>




          <b-card class="uBind">
            <b-row>
              <b-col md="12" style="margin-bottom: 20px;margin-top:0px; text-align: left;">
                <div style="max-width: 600px; margin: auto; margin-bottom: 20px" class="infoText">The information
                  provided
                  is
                  to be regarded as general advice. Whilst we may have collected risk information, your personal
                  objectives,
                  needs or financial situations were not taken into account when preparing this information.</div>

                <div style="max-width: 600px; margin: auto;" class="infoText">We recommend that you consider the
                  suitability
                  of this general advice, in respect of your objectives, financial situation and needs before acting on
                  it.
                  You should obtain and consider the relevant product disclosure statement before making any decision to
                  purchase this financial product. </div>
              </b-col>
            </b-row>
            <b-row class=" my-4">
              <b-col cols="12" style="margin-bottom: 0px;margin-top:0px; text-align: center;">
                <base-input :rules="{ required: { allowFalse: false } }" name="above">
                  <b-form-checkbox v-model="model.agreeAdviceDisclosure">
                    <span>I have read the general advice disclosure and accept the conditions.</span>
                  </b-form-checkbox>
                </base-input>
              </b-col>
            </b-row>
            <b-row class=" my-4">
              <b-col cols="12" style="margin-bottom: 10px;margin-top:0px; text-align: center;">
                <base-input :rules="{ required: { allowFalse: false } }" name="above">
                  <b-form-checkbox v-model="model.agree">
                    <span>I confirm that the above information I have provided is true and correct.</span>
                  </b-form-checkbox>
                </base-input>
              </b-col>
            </b-row>
            <b-row class="" style="margin-top: 25px;">
              <b-col md="12" class="answerText" style="margin-bottom:0px; text-align: center;">
                <div style="margin-bottom: 20px;">I have read the duty of disclosure and accept the conditions.</div>
                <div>
                  <base-input :rules="{ required: { allowFalse: true } }" name="Acceptance of Duty of Disclosure">
                    <el-select id="acceptDOD" v-model="model.acceptDOD" style="width:200px"
                      class="duty-disclosure-select">
                      <el-option label="-- Please select --" :value="null"></el-option>
                      <el-option label="No" :value="false"></el-option>
                      <el-option label="Yes" :value="true"></el-option>
                    </el-select>
                  </base-input>
                </div>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" style="text-align: center;">

                <div ref="paymentTermsSection" id="paymentTermsSection">
                  <div v-if="isCloudfloatRetryFlow" class="infoText payment-terms-retry-notice">
                    There was a problem completing your Cloudfloat monthly payment setup.
                    You can still proceed by paying annually using the option below.
                    Once you accept the quote, you will be sent an invoice for the full premium amount.
                  </div>

                  <h2 style="font-size: 17pt" class="secondary-card-header payment-terms-heading">
                    Payment Terms
                  </h2>
                  <div v-if="!isCloudfloatRetryFlow" class="infoText payment-terms-helper">
                    Please Select your Payment Terms
                  </div>

                  <div class="payment-terms-panel">
                    <ButtonRadioGroup
                      v-if="!isCloudfloatRetryFlow"
                      v-model="paymentTerm"
                      :options="paymentTermOptions"
                      class="payment-terms-toggle"
                      buttonClasses="payment-term-button"
                      @change="paymentTermChanged"
                    />

                    <div v-if="paymentTerm == 'monthly'" class="infoText payment-terms-placeholder payment-terms-monthly-panel">
                      <div v-if="isLoadingCloudfloatQuote" class="cloudfloat-loading-inline">
                        <div class="cloudfloat-orbit-spinner">
                          <div class="orbit"></div>
                          <div class="orbit"></div>
                          <div class="orbit"></div>
                        </div>
                        <p class="payment-terms-loading-text">Loading monthly installment options...</p>
                      </div>

                      <div v-else-if="hasCloudfloatQuoteData" class="cloudfloat-quote">
                        <div class="cloudfloat-brand">
                          <div style="margin-bottom: 0px;" class="cloudfloat-powered-by">Powered by</div>
                          <img
                            src="/img/brand/cloudfloat-logo.png"
                            alt="Cloudfloat"
                            class="cloudfloat-logo"
                          />
                        </div>

                        <div class="cloudfloat-card">
                          <div class="cloudfloat-summary-row">
                            <span>Annual Premium</span>
                            <strong>{{ formatCentsAsCurrency(cloudfloatQuoteData.annual_premium_in_cents) }}</strong>
                          </div>

                          <div class="cloudfloat-divider"></div>

                          <div class="cloudfloat-schedule">
                            <div class="cloudfloat-schedule-item">
                              <div class="cloudfloat-schedule-track">
                                <span style="width:24px; height:24px;" class="cloudfloat-step cloudfloat-step--active">1</span>
                                <span class="cloudfloat-step-line"></span>
                              </div>
                              <div class="cloudfloat-schedule-content">
                                <span class="cloudfloat-schedule-label">Due today</span>
                                <strong class="cloudfloat-schedule-amount">{{
                                  formatCentsAsCurrency(cloudfloatQuoteData.upfront_amount_in_cents)
                                }}</strong>
                              </div>
                            </div>

                            <div class="cloudfloat-schedule-item">
                              <div class="cloudfloat-schedule-track">
                                <span class="cloudfloat-step-dots" aria-hidden="true">
                                  <span></span><span></span><span></span>
                                </span>
                                <span class="cloudfloat-step-line"></span>
                              </div>
                              <div class="cloudfloat-schedule-content">
                                <span style="margin-top: 6px;" class="cloudfloat-schedule-label">Monthly</span>
                                <strong class="cloudfloat-schedule-amount">{{
                                  formatCentsAsCurrency(cloudfloatQuoteData.recurring_instalment_amount_in_cents)
                                }}</strong>
                              </div>
                            </div>

                            <div class="cloudfloat-schedule-item cloudfloat-schedule-item--last">
                              <div class="cloudfloat-schedule-track">
                                <span style="width:25px; height:25px; background: #dbdcdd; margin-top: 3px;" class="cloudfloat-step cloudfloat-step--final">{{
                                  cloudfloatQuoteData.total_number_instalments
                                }}</span>
                              </div>
                              <div class="cloudfloat-schedule-content">
                                <span class="cloudfloat-schedule-label">{{ cloudfloatFinalInstalmentDateFormatted }}</span>
                                <strong class="cloudfloat-schedule-amount">{{
                                  formatCentsAsCurrency(cloudfloatQuoteData.recurring_instalment_amount_in_cents)
                                }}</strong>
                              </div>
                            </div>
                          </div>

                          <div class="cloudfloat-divider"></div>

                          <div class="cloudfloat-summary-row">
                            <span>Fee per instalment (incl GST)</span>
                            <strong>{{ formatCentsAsCurrency(cloudfloatQuoteData.fee_per_instalment_in_cents) }}</strong>
                          </div>
                          <div class="cloudfloat-summary-row cloudfloat-summary-row--total">
                            <span>Total to repay</span>
                            <strong>{{ formatCentsAsCurrency(cloudfloatQuoteData.final_agreed_amount_in_cents) }}</strong>
                          </div>
                        </div>

                        <base-button
                          type="danger"
                          class="cloudfloat-cta-button"
                          :disabled="isSavingCloudfloatQuote"
                          @click="continueToCloudfloat()">
                          <span v-if="isSavingCloudfloatQuote">
                            <b-spinner small class="mr-2"></b-spinner>
                            Saving...
                          </span>
                          <span v-else>Continue to Cloudfloat to setup payment plan</span>
                        </base-button>
                      </div>

                      <div v-else-if="cloudfloatQuoteLoadError" class="payment-terms-load-error">
                        {{ cloudfloatQuoteLoadError }}
                      </div>
                    </div>

                    <div v-if="paymentTerm == 'annual'" class="payment-terms-actions">
                      <div class="infoText payment-terms-placeholder">
                        You will be sent an invoice for the premium amount of <b>{{ estimatedPremiumFormatted }}</b>,
                        which will require payment within 14 days. You will also be sent your Documentation,
                        including Certificate of Currency.
                      </div>

                      <base-button
                        :disabled="!(model.agree && model.agreeAdviceDisclosure && model.acceptDOD == true) || isAcceptingQuote || filesUploading"
                        @click="acceptQuote()" type="danger" class="mb-4 bg-danger">
                        <span v-if="isAcceptingQuote">
                          <b-spinner small class="mr-2"></b-spinner>
                          Processing...
                        </span>
                        <span v-else>Accept Quote</span>
                      </base-button>
                    </div>
                  </div>
                </div>
              </b-col>
            </b-row>



          </b-card>
        </div>
        <div class="container-fluid mt--6" style="margin-top: -7.5rem !important"
          v-if="model != null && step == 'accepted'">

          <!-- <base-button @click="goBack()" type="uBind" class="mt-2 mt-sm-0 mb-4" style="width:150px"><i
          class="fas fa-angle-left pr-3"></i>Back</base-button> -->

          <b-card no-body class="mb-4 uBind">



            <b-card-header>
              <h2 style="font-size: 17pt" class="secondary-card-header">
                Thank you
              </h2>

              <!-- <h3 class="mb-0">Premium</h3> -->
            </b-card-header>
            <b-card-body>

              <b-row>
                <b-col md="12">
                  <div v-if="isCloudfloatPaymentComplete" class="infoText">
                    Thank you. Your Cloudfloat monthly payment setup has been completed.
                    A member of the Insurance Advisernet team will be in touch shortly.
                  </div>
                  <div v-else class="infoText">Thank you for completing the disclosure questions. A member of the Insurance
                    Advisernet team is preparing your documents and will be emailed to you shortly.</div>

                </b-col>
              </b-row>

            </b-card-body>
          </b-card>

        </div>
      </form>
    </validation-observer>
  </div>
</template>

<script>
import BaseInput from "../../components/Inputs/BaseInput.vue";
import { Select, Option } from "element-ui";
import { dropDowns } from "../../assets/data/dropdown_values";
import { quoteFormMethods } from "../../helpers/quoteForm";
import { GlobalStore } from "../../globalStore";
import { emailMethods } from "../../helpers/email";
import { appFunctions } from "../../helpers/appFunctions";
import { protecsureFunctions } from "../../helpers/protecsure";
import { entsiaFunctions } from "../../helpers/entsia";
import Spinner from "../../views/dashboard/Spinner.vue";
import FileUpload from 'vue-upload-component'
import { GlobalMethods } from "../../globalMethods";
import { formattingMethods } from "../../helpers/formatting";
import VueMultiselectComponent from 'vue-multiselect-component'
import ButtonRadioGroup from "../../components/ButtonRadioGroup.vue";
// import QuotesAndPoliciesVue from "../views/QuotesAndPolicies.vue";

export default {
  name: "QuoteForm",
  policy_id: "",
  selectedCustomerId: 0,
  props: {
    rawModel: null,
    editModel: {
      type: Object
    },
    formMode: {
      type: String,
      default: "create"
    }
  },



  //                   <el-option label="Locked Shed" value="Locked Shed" />
  //                   <el-option label="Locked Trailer" value="Locked Trailer" />
  //                   <el-option label="Secure Compound" value="Secure Compound" />
  //                   <el-option label="Back to base alarm" value="Back to base alarm" />
  //                   <el-option label="24 hour tracking device" value="24 hour tracking device" />
  //                   <el-option label="Wheel lock nuts" value="Wheel lock nuts" />
  //                   <el-option label="Immoboliser" value="Immoboliser" />
  //                   <el-option label="Microdotting" value="Microdotting" />
  //                   <el-option label="Other" value="other" />




  data() {
    return {
      //value: [],
      paymentTerm: "annual",
      isLoadingCloudfloatQuote: false,
      cloudfloatQuoteRequested: false,
      cloudfloatQuoteResponse: null,
      cloudfloatQuoteLoadError: null,
      isSavingCloudfloatQuote: false,
      isAcceptingQuote: false,
      quoteModified: false,
      selectedSecurity1: [],
      excessOptions: [],
      formInitData: null,
      security1_other: "",
      security1options: [
        { id: 'Not Sure', label: 'Not Sure' },
        { id: 'On the street', label: 'On the street' },
        { id: 'Garage', label: 'Garage' },
        { id: 'Driveway of property', label: 'Driveway of property' },
        { id: 'Other', label: 'Other' },
      ],
      selectedSecurity2: [],
      security2_other: "",
      security3: "",
      security2options: [
        { id: 'Not Sure', label: 'Not Sure' },
        { id: 'Locked Shed', label: 'Locked Shed' },
        { id: 'Locked Trailer', label: 'Locked Trailer' },
        { id: 'Back to Base Alarm', label: 'Back to Base Alarm' },
        { id: '24 hour tracking device', label: '24 hour tracking device' },
        { id: 'Wheel lock nuts', label: 'Wheel lock nuts' },
        { id: 'Immoboliser', label: 'Immoboliser' },
        { id: 'Microdotting', label: 'Microdotting' },
        { id: 'Other', label: 'Other' },
      ],
      selectedSecurity4: [],
      security4_other: "",
      security4options: [
        { id: 'Not Sure', label: 'Not Sure' },
        { id: 'Locked Shed', label: 'Locked Shed' },
        { id: 'Locked Trailer', label: 'Locked Trailer' },
        { id: 'Secure Compound', label: 'Secure Compound' },
        { id: 'Back to Base Alarm', label: 'Back to Base Alarm' },

        { id: '24 hour tracking device', label: '24 hour tracking device' },
        { id: 'Wheel lock nuts', label: 'Wheel lock nuts' },
        { id: 'Immoboliser', label: 'Immoboliser' },
        { id: 'Microdotting', label: 'Microdotting' },
        { id: 'Other', label: 'Other' },
      ],
      isLoading: false,
      formInitData: { equipmentCategories: [] },
      selectEquipmentItems: [],
      quoteNotes: [],
      certContents: "",
      realmApp: null,
      //formMode: "create",
      financiers: [
        { label: "Don't know", value: "Don't know" },
        ...dropDowns.financiers,
      ],
      equipmentTypes: dropDowns.protecSureEquipmentTypes,
      states: dropDowns.states,
      operatingAreas: dropDowns.operatingAreas,
      usedOnPublicRoadOptions: dropDowns.usedOnPublicRoadOptions,
      validated: false,
      financierOtherDisabled: true,
      enteredInsuredName: "",
      customerList: [],
      fileList: [],
      uploaderKey: 'customerQuoteFileUploader',
      step: "step1",
      model: null,
      mode: "view"
    };
  },
  computed: {

    isFormValid() {
      var isValid = true;

      isValid = this.selectEquipmentItems.length > 0;

      return isValid;
    },
    fieldsDisabled() {
      return this.getDisabledFields(
        this.formMode,
        this.model.Customer_policy_status
      );
    },
    formRules() {
      return quoteFormMethods.getFormRules("in_progress");
    },
    brokerObj() {
      return GlobalStore.brokerObj;
    },
    totalPremiumIncFeesDisplay() {
      const raw = this.model?.Data_obj?.totalPremiumIncFees;
      if (raw === null || raw === undefined || raw === "") {
        return "";
      }
      const n = Number(raw);
      if (Number.isNaN(n)) {
        return "";
      }
      return n.toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    },
    estimatedPremiumOverlayDisplay() {
      const raw = this.model?.Data_obj?.totalPremiumIncFees;
      if (raw === null || raw === undefined || raw === "") {
        return "";
      }
      const n = Number(raw);
      if (!Number.isFinite(n)) {
        return "";
      }
      return this.formatCurrencyString(n);
    },
    estimatedPremiumFormatted() {
      if (!this.model || !this.model.Data_obj || this.model.Data_obj.totalPremiumIncFees == null) {
        return this.formatCurrencyString(0);
      }
      return this.formatCurrencyString(parseFloat(this.model.Data_obj.totalPremiumIncFees));
    },
    filesUploading() {
      return (this.fileList || []).some((f) => !f.success);
    },
    isCloudfloatRetryFlow() {
      return String(this.$route?.query?.flow || "").toLowerCase() === "retry";
    },
    isCloudfloatPaymentComplete() {
      return this.model && this.model.cloudFloatStatus === "monthlyFlowApproved";
    },
    paymentTermOptions() {
      const options = [
        { value: "annual", label: "Annual Payment" },
        { value: "monthly", label: "Monthly installments" },
      ];
      if (this.isCloudfloatRetryFlow) {
        return options.filter((option) => option.value === "annual");
      }
      return options;
    },
    cloudfloatQuoteData() {
      return this.cloudfloatQuoteResponse && this.cloudfloatQuoteResponse.data
        ? this.cloudfloatQuoteResponse.data
        : this.cloudfloatQuoteResponse;
    },
    hasCloudfloatQuoteData() {
      const data = this.cloudfloatQuoteData;
      return !!(data && data.annual_premium_in_cents != null);
    },
    cloudfloatFinalInstalmentDateFormatted() {
      const data = this.cloudfloatQuoteData;
      if (!data) {
        return "";
      }

      const totalInstalments = Number(data.total_number_instalments);
      const remainingInstalments = Number(data.number_remaining_instalments);
      const recurringCount =
        Number.isFinite(remainingInstalments) && remainingInstalments > 0
          ? remainingInstalments
          : Number.isFinite(totalInstalments)
            ? Math.max(totalInstalments - 1, 0)
            : 0;

      if (recurringCount <= 0) {
        return this.$moment().format("D MMMM YYYY");
      }

      let firstRecurringDate;
      if (data.payout_date) {
        firstRecurringDate = this.$moment(data.payout_date);
      } else if (data.issued_at) {
        firstRecurringDate = this.$moment(data.issued_at).add(1, "month");
      } else {
        firstRecurringDate = this.$moment().add(1, "month");
      }

      return firstRecurringDate
        .clone()
        .add(recurringCount - 1, "months")
        .format("D MMMM YYYY");
    },
  },
  watch: {
    paymentTerm(value) {
      if (value === "monthly") {
        this.requestMonthlyInstallmentQuote(true);
      }
    },
  },
  methods: {
    formatCurrencyString(num) {
      if (!Number.isFinite(num)) {
        return "";
      }
      return formattingMethods.formatCurrencyString(num);
    },
    formatCentsAsCurrency(value) {
      if (value === null || value === undefined || value === "") {
        return "";
      }

      const amount = Number(value) / 100;
      if (!Number.isFinite(amount)) {
        return "";
      }

      return "$" + amount.toLocaleString("en-AU", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });
    },
    paymentTermChanged(value) {
      if (value == "monthly") {
        this.requestMonthlyInstallmentQuote(true);
      }
    },
    async requestMonthlyInstallmentQuote(force = false) {
      if (this.isLoadingCloudfloatQuote) {
        return;
      }
      if (!force && this.cloudfloatQuoteRequested) {
        return;
      }

      this.isLoadingCloudfloatQuote = true;
      this.cloudfloatQuoteLoadError = null;
      if (force) {
        this.cloudfloatQuoteResponse = null;
        this.cloudfloatQuoteRequested = false;
      }

      const annualPremiumInCents = Math.round(parseFloat(this.model.Data_obj.totalPremiumIncFees) * 100);

      try {
        const response = await entsiaFunctions.requestCloudfloatQuote(
          annualPremiumInCents,
          {
            abn: this.model.Customer_abn || this.model.insuredABN || "",
            first_name: this.model.Customer_contact_first_name || "",
            middle_name: "",
            last_name: this.model.Customer_contact_last_name || "",
            email: this.model.Customer_contact_email || "",
            phone: this.model.Customer_contact_number || ""
          },
          this.model.Customer_policy_guid || ""
        );
        this.cloudfloatQuoteResponse = response;
        this.cloudfloatQuoteRequested = true;
      } catch (error) {
        console.error("Cloudfloat quote request failed", error);
        this.cloudfloatQuoteLoadError = "Unable to load monthly installment options. Please try again.";
        this.cloudfloatQuoteRequested = true;
      } finally {
        this.isLoadingCloudfloatQuote = false;
      }
    },
    async continueToCloudfloat() {
      const guid = this.model && this.model.Customer_policy_guid;
      if (!guid) {
        console.error("continueToCloudfloat: no Customer_policy_guid on model");
        return;
      }
      if (!this.cloudfloatQuoteData) {
        return;
      }

      this.isSavingCloudfloatQuote = true;
      try {
        const response = await entsiaFunctions.saveMotorCloudfloatQuote(
          guid,
          this.cloudfloatQuoteData
        );
        if (response && response.updatedQuote) {
          this.model.cloudfloatQuote = response.updatedQuote.cloudfloatQuote;
        } else {
          this.model.cloudfloatQuote = this.cloudfloatQuoteData;
        }

        const checkoutUrl =
          (response && response.checkoutUrl) ||
          this.buildCloudfloatCheckoutUrl(this.cloudfloatQuoteData.quote_id);

        if (checkoutUrl) {
          window.location.assign(checkoutUrl);
        } else {
          console.error("continueToCloudfloat: missing checkout URL");
        }
      } catch (error) {
        console.error("Failed to save Cloudfloat quote to customerPolicy", error);
      } finally {
        this.isSavingCloudfloatQuote = false;
      }
    },
    buildCloudfloatCheckoutUrl(quoteId) {
      if (!quoteId) {
        return "";
      }

      const apiEndpoint = String(process.env.VUE_APP_APIENDPOINT || "");
      const siteUrl = String(process.env.VUE_APP_SITEURL || "");
      const isUat = /uat/i.test(apiEndpoint) || /staging/i.test(siteUrl);

      const base = isUat
        ? "https://checkout.uat.cloudfloat.com"
        : "https://checkout.cloudfloat.com";

      return `${base}/${quoteId}`;
    },
    scrollToPaymentTerms() {
      const myEl = this.$refs.paymentTermsSection;
      if (!myEl) {
        return;
      }

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#paymentTermsSection",
      });
    },
    applyCloudfloatRetryFlow() {
      if (!this.isCloudfloatRetryFlow) {
        return;
      }

      this.paymentTerm = "annual";
      this.step = "step2";

      this.$set(this.model, "agreeAdviceDisclosure", true);
      this.$set(this.model, "agree", true);
      this.$set(this.model, "acceptDOD", true);

      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToPaymentTerms();
        }, 300);
      });
    },
    quoteChanged() {
      this.quoteModified = true;
    },
    sanitiseDecimalInput(value) {
      const sanitisedValue = String(value || "").replace(/[^0-9.]/g, "");
      const [integerPart, ...decimalParts] = sanitisedValue.split(".");
      return decimalParts.length > 0
        ? integerPart + "." + decimalParts.join("")
        : integerPart;
    },
    parseSumInsured(value) {
      const parsed = parseFloat(this.sanitiseDecimalInput(value));
      return Number.isFinite(parsed) ? parsed : 0;
    },
    onEquipmentValueInput(value) {
      this.$set(this.model.Data_obj, "totalSumInsured", this.sanitiseDecimalInput(value));
      this.quoteChanged();
    },
    getQuote() {

      console.log(this.formInitData.equipmentExcesses);
      console.log(this.model.totalExcess);
      
      //.find(f => f.excessValue == this.model.totalExcess));

      var excessMatch = (this.formInitData.equipmentExcesses || []).find(
        f => f.excessValue == this.model.totalExcess
      );
      if (!excessMatch) {
        this.$toasted
          .error("Please select a valid excess before getting a new premium.", {
            position: "bottom-center"
          })
          .goAway(4000);
        return;
      }
      var excessId = excessMatch.excessId;
      var sumInsured = this.parseSumInsured(this.model.Data_obj.totalSumInsured);

      if (!this.model.Quote_data || !Array.isArray(this.model.Quote_data.equipmentItems) || !this.model.Quote_data.equipmentItems.length) {
        this.$toasted
          .error("Unable to update premium — equipment details are missing on this quote.", {
            position: "bottom-center"
          })
          .goAway(4000);
        return;
      }

      // Continue-quote UI edits total SI; apply it to every stored item proportionally
      // when there is only one item (normal path), otherwise set item[0] to the total.
      if (this.model.Quote_data.equipmentItems.length === 1) {
        this.model.Quote_data.equipmentItems[0].specifiedSumInsured = sumInsured;
        this.model.Quote_data.equipmentItems[0].excessId = excessId;
      } else {
        this.model.Quote_data.equipmentItems[0].specifiedSumInsured = sumInsured;
        this.model.Quote_data.equipmentItems[0].excessId = excessId;
      }

      if (this.model.Data_obj.equipmentItems && this.model.Data_obj.equipmentItems[0]) {
        this.model.Data_obj.equipmentItems[0].sumInsured = sumInsured;
      }

      this.model.Data_obj.totalSumInsured = sumInsured;

      this.model.Quote_data.quoteId = this.model.Quote_id;

      //console.log(this.model.Quote_data);

      this.isLoading = true;

      protecsureFunctions.updateQuotePublic(this.model.Quote_data).then(async (resp) => {
        console.log(resp);

        this.isLoading = false;

        this.$set(this.model, "Data_obj", {
          ...(this.model.Data_obj || {}),
          ...resp,
          totalPremiumIncFees: resp.totalPremiumIncFees,
          totalSumInsured: resp.totalSumInsured != null ? resp.totalSumInsured : sumInsured,
        });

        if (resp.equipmentItems && this.model.Quote_data && this.model.Quote_data.equipmentItems) {
          this.model.Quote_data.equipmentItems = this.model.Quote_data.equipmentItems.map((item, index) => {
            const matched = resp.equipmentItems[index];
            if (!matched) {
              return item;
            }
            return {
              ...item,
              specifiedSumInsured: matched.sumInsured,
              excessId: item.excessId || excessId,
            };
          });
        }

        this.quoteModified = false;
      }).catch(() => {
        this.isLoading = false;
      })
    },
    isPage1FormValid() {

      console.log(this.security1_other);

      var isValid = true;


      console.log(this.fileList.length);
      console.log(this.model.descriptionOfAsset);


      //if (this.fileList.length == 0 && (!this.model.descriptionOfAsset || this.model.descriptionOfAsset == "")) {
      if (!(this.fileList.length > 0 || this.model.descriptionOfAsset != "")) {
        isValid = false;
      }



      if (this.model.Data_obj.totalSumInsured > 125000) {

        // if (this.selectedSecurity1.length == 0 || this.selectedSecurity2.length == 0 || this.selectedSecurity4.length == 0) {
        //   return false;
        // }


        // if (this.security3 == "") {
        //   return false;
        // }

        if (this.selectedSecurity1.includes("Other") && this.security1_other == "") {
          return false;
        }

        if (this.selectedSecurity2.includes("Other") && this.security2_other == "") {
          return false;
        }

        if (this.selectedSecurity4.includes("Other") && this.security4_other == "") {
          return false;
        }
      }

      // if (!(this.fileList.length > 0 || this.model.financier)) {
      //   return false;
      // }

      if (!this.model.financier) {
        isValid = false;
      }

      if (this.model.financier == 'Other' && (!this.model.financierOther || this.model.financierOther == '')) {
        isValid = false;
      }





      return isValid;


    },
    async customAction(file) {
      const blob = await fetch(file.blob).then((res) => res.blob());
      var reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onloadend = async () => {

        console.log(file);
        console.log(this.$route.params);



        var base64data = reader.result;

        const filename = file.name;

        var attachmentResp = await appFunctions.addFinanceFileAttachment({
          Customer_policy_id: this.model.Customer_policy_guid,
          fileContent: base64data,
          filename,
          guid: GlobalMethods.uuidv4(),
          createdDateTime: new Date(),
          type: "ps-equipment-invoice",
        });


        //await appFunctions.sendPSQuoteEmail(this.$route.params.id, attachmentResp.insertedId);

        //console.log(attachmentResp);

        return null;
      };
    },
    /**
     * Has changed
     * @param  Object newFile Read only
     * @param  Object oldFile Read only
     */
    inputFile: function (newFile, oldFile) {

      if (newFile && oldFile && !newFile.active && oldFile.active) {
        // Get response data
        console.log("response", newFile.response);
        if (newFile.xhr) {
          //  Get the response status code
          console.log("status", newFile.xhr.status);
        }
      }

      setTimeout(() => {
        if (
          Boolean(newFile) !== Boolean(oldFile) ||
          oldFile.error !== newFile.error
        ) {
          this.$refs[this.uploaderKey].active = true;
        }
      }, 2000);
    },
    /**
     * Pretreatment
     * @param  Object newFile Read and write
     * @param  Object oldFil  Read only
     * @param  Function prevent Prevent changing
     */
    inputFilter: function (newFile, oldFile, prevent) {
      let pending = (this.fileList || []).some((f) => f !== newFile && !f.success);
      if (newFile && !newFile.success) {
        pending = true;
      }
      this.$emit("disableNextStep", pending);

      if (newFile && !oldFile) {
        // Filter non-image file
        if (
          !/\.(jpeg|jpe|jpg|gif|png|webp|doc|docx|pdf|xls|xlsx|csv)$/i.test(
            newFile.name
          )
        ) {
          return prevent();
        }
      }

      // Create a blob field
      newFile.blob = "";
      let URL = window.URL || window.webkitURL;
      if (URL && URL.createObjectURL) {
        newFile.blob = URL.createObjectURL(newFile.file);
      }
    },
    async acceptQuote() {
      if (this.isAcceptingQuote) {
        return;
      }
      this.isAcceptingQuote = true;
      console.log(this.model);

      var _modelToSend = this.model;


      _modelToSend.security1 = this.selectedSecurity1.toString();

      if (this.selectedSecurity1.includes("Other") && this.security1_other) {
        _modelToSend.security1 = _modelToSend.security1 + "," + this.security1_other
      }

      _modelToSend.security2 = this.selectedSecurity2.toString();

      if (this.selectedSecurity2.includes("Other") && this.security2_other) {
        _modelToSend.security2 = _modelToSend.security2 + "," + this.security2_other
      }

      _modelToSend.security3 = this.security3;

      _modelToSend.security4 = this.selectedSecurity4.toString();

      if (this.selectedSecurity4.includes("Other") && this.security4_other) {
        _modelToSend.security4 = _modelToSend.security4 + "," + this.security4_other
      }


      //console.log(_modelToSend);

      try {
        await protecsureFunctions.acceptPSQuote(_modelToSend)
          .then(resp => {
            console.log(resp);

            this.step = "accepted";
            //this.customerList = resp.data.filter(data => data && data.Customer_insured_name)
          });
      } finally {
        this.isAcceptingQuote = false;
      }



      //this.model.acceptDOD = this.
    },
    confirm() {
      this.scrollUp();

      this.step = "step2";

      setTimeout(() => {
        this.$refs.formValidator.validate();
      }, 500);
    },
    getDisabledFields(mode) {
      var retObj = {};
      if (mode == "edit" || mode == "create") {
        retObj = {
          policyStart: false,
          insuredName: false,
          insuredABN: false,
          businessDesc: false,
          businessActivity: false,
          contactFName: false,
          contactLName: false,
          contactEmail: false,
          contactPhone: false,
          insuredAddress: false,
          insuredStreet: false,
          insuredCity: false,
          insuredState: false,
          insuredPostcode: false,
          businessAddress: false,
          businessStreet: false,
          businessCity: true,
          businessState: true,
          businessPostcode: true,
          associatedEntities: false,
          stampDutyStatus: false,
          tradingTime: false,
          otherTradingNames: false,

          equipmentDescription: false,
          equipmentValue: false,
          equipmentCondition: false,
          operatingArea: false,
          usedOnPublicRoad: false,
          //insurancePeriod: "12 Months",
          financier: false,
          Quote_Ref_No: true,
          registeredForGst: true,
          claims3Years: true,
          anyExpensiveItems: true
        };
      } else {
        retObj = {
          policyStart: true,
          insuredName: true,
          insuredABN: true,
          businessDesc: true,
          businessActivity: true,
          contactFName: true,
          contactLName: true,
          contactEmail: true,
          contactPhone: true,
          insuredAddress: true,
          insuredStreet: true,
          insuredCity: true,
          insuredState: true,
          insuredPostcode: true,
          businessAddress: true,
          businessStreet: true,
          businessCity: true,
          businessState: true,
          businessPostcode: true,
          associatedEntities: true,
          stampDutyStatus: true,
          tradingTime: true,
          otherTradingNames: true,

          equipmentDescription: true,
          equipmentValue: true,
          equipmentCondition: true,
          operatingArea: true,
          usedOnPublicRoad: true,
          //insurancePeriod: "12 Months",
          financier: true,
          Quote_Ref_No: true,
          registeredForGst: true,
          claims3Years: true,
          anyExpensiveItems: true
        };
      }
      return retObj;
    },
    // selectCustomer(e) {
    //   console.log(e);
    //   //console.log(this.model.insuredName);
    //   if (e) {
    //     var findCustomer = this.customerList.find(f => f.value == e);
    //     this.enteredInsuredName = findCustomer.label.replace(
    //       / *\([^)]*\) */g,
    //       ""
    //     );
    //     this.model.insuredName = findCustomer.label.replace(
    //       / *\([^)]*\) */g,
    //       ""
    //     );

    //     console.log(findCustomer);

    //     GlobalStore.realmApp.functions
    //       .crud_customer("get", {
    //         Customer_id: parseInt(e)
    //       })
    //       .then(resp => {
    //         console.log(resp);
    //         var d = resp.data;
    //         this.model.businessDesc = d.Customer_business_description;
    //         this.model.contactEmail = d.Customer_contact_email;
    //         this.model.contactPhone = d.Customer_contact_number;
    //         this.model.insuredStreet = d.Customer_contact_street;
    //         this.model.insuredCity = d.Customer_contact_city;
    //         this.model.insuredState = d.Customer_state;
    //         this.model.insuredPostcode = d.Customer_postcode;
    //         this.model.insuredName = d.Customer_insured_name;
    //         this.model.insuredABN = d.Customer_abn;
    //         this.model.contactFName = d.Customer_contact_first_name;
    //         this.model.contactLName = d.Customer_contact_last_name;

    //         this.fieldsDisabled.businessDesc = true;
    //         this.fieldsDisabled.contactEmail = true;
    //         this.fieldsDisabled.contactPhone = true;
    //         this.fieldsDisabled.insuredStreet = true;
    //         this.fieldsDisabled.insuredCity = true;
    //         this.fieldsDisabled.insuredState = true;
    //         this.fieldsDisabled.insuredPostcode = true;
    //         //this.fieldsDisabled.insuredName = true;
    //         this.fieldsDisabled.insuredABN = true;
    //         this.fieldsDisabled.contactFName = true;
    //         this.fieldsDisabled.contactLName = true;

    //         this.selectedCustomerId = d.Customer_id;
    //       });
    //   }
    //   //   / *\([^)]*\) */g,
    //   //   ""
    //   // );
    // },
    // // InsuredNameBlurred(e) {
    // //   console.log(e);
    // //   this.model.insuredName = this.enteredInsuredName;

    // //   // if (this.model.insuredName.includes("(")) {
    // //   //   this.model.insuredName = this.model.insuredName.replace(
    // //   //     / *\([^)]*\) */g,
    // //   //     ""
    // //   //   );
    // //   // }
    // // },
    // // setInsuredName(e) {
    // //   //console.log(e);
    // //   //this.model.insuredName = e.target.value;

    // //   GlobalStore.realmApp.functions
    // //     .crud_customer("searchCustomerByRealmId", {
    // //       Realm_user_id: GlobalStore.brokerObj.Realm_user_id,
    // //       searchText: e.target.value
    // //     })
    // //     .then(resp => {
    // //       console.log(resp);
    // //       this.customerList = resp.data;
    // //     });

    // //   this.enteredInsuredName = e.target.value;
    // // },
    selectExcess(item, option) {

      item.selectedExcess = item.value;
      item.selectedExcessId = item.id;


      var itemToUpdate = this.selectEquipmentItems.find(f => f.categoryItemId == option.categoryItemId)
      console.log(itemToUpdate);


      itemToUpdate.selectedExcess = item.value;
      itemToUpdate.selectedExcessId = item.id;


      console.log(item);
      console.log(option);
    },
    toggleEquipmentItem(eqItem) {


      var findEI = this.selectEquipmentItems.find(f => f.categoryItemId == eqItem.categoryItemId);

      if (!findEI) {

        console.log(eqItem);

        var minExcess = 0;
        var minExcessId = 0;

        var excessOptions = this.formInitData.equipmentExcesses.map(m => {
          var enabled = false;

          // Default to the lowest allowed excess (first match), not the last.
          if (m.excessValue >= eqItem.minimumExcessAllowed) {
            enabled = true;
            if (!minExcessId || m.excessValue < minExcess) {
              minExcess = m.excessValue;
              minExcessId = m.excessId;
            }
          }
          return {
            label: "$" + m.excessValue,
            value: m.excessValue,
            id: m.excessId,
            enabled: enabled,
            selected: false
          }

        });



        this.selectEquipmentItems.push({
          categoryItemId: eqItem.categoryItemId,
          categoryName: eqItem.categoryName,
          excessOptions: excessOptions,
          //selectedExcess: minExcess,
          //selectedExcessId: minExcessId,
          selectedExcess: 0,
          selectedExcessId: 0,
          insuredAmount: 0
          // {
          //   label: "$100",
          //   value: 100,
          //   enabled: false
          // },
          // {
          //   label: "$250",
          //   value: 250,
          //   enabled: true
          // },
          // {
          //   label: "$500",
          //   value: 500,
          //   enabled: true
          // },
          // {
          //   label: "$1000",
          //   value: 1000,
          //   enabled: true
          // }

        })

        //.map((m) => { return { ...m, ...{ selectedExcess: 0, insuredAmount: 0 } } })


      } else {
        this.selectEquipmentItems = this.selectEquipmentItems.filter(f => f.categoryItemId != eqItem.categoryItemId);
      }



    },
    selectCustomer(e) {
      this.selected = true
      const findCustomer = this.customerList.find(f => f.Customer_id == e);
      this.enteredInsuredName = findCustomer ? findCustomer.Customer_insured_name : this.enteredInsuredName
      if (findCustomer) {
        this.formData(findCustomer, true)
      } else {
        this.formData(null, false)
      }
    },
    formData(data, disabled) {
      this.model.insuredName = data ? data.Customer_insured_name : this.enteredInsuredName
      this.model.businessDesc = data ? data.Customer_business_description : ""
      this.model.contactEmail = data ? data.Customer_contact_email : ""
      this.model.contactPhone = data ? data.Customer_contact_number : ""
      this.model.insuredStreet = data ? data.Customer_contact_street : ""
      this.model.insuredCity = data ? data.Customer_contact_city : ""
      this.model.insuredState = data ? data.Customer_state : ""
      this.model.insuredPostcode = data ? data.Customer_postcode : ""
      this.model.insuredABN = data ? data.Customer_abn : ""
      this.model.contactFName = data ? data.Customer_contact_first_name : ""
      this.model.contactLName = data ? data.Customer_contact_last_name : ""
      this.model.selectedCustomerId = data ? data.Customer_id : ""
      this.model.Ubind_customer_id = data ? data.Ubind_customer_id : ""
      this.fieldsDisabled.insuredName = disabled
      this.fieldsDisabled.businessDesc = disabled
      this.fieldsDisabled.contactEmail = disabled
      this.fieldsDisabled.contactPhone = disabled
      this.fieldsDisabled.insuredStreet = disabled
      this.fieldsDisabled.insuredCity = disabled
      this.fieldsDisabled.insuredState = disabled
      this.fieldsDisabled.insuredPostcode = disabled
      this.fieldsDisabled.insuredABN = disabled
      this.fieldsDisabled.contactFName = disabled
      this.fieldsDisabled.contactLName = disabled

      this.fieldsDisabled.Quote_Ref_No = disabled

    },
    InsuredNameBlurred(e) {
      this.model.insuredName = this.enteredInsuredName;
    },
    setInsuredName(e) {
      this.enteredInsuredName = e.target.value;
    },
    visibleChange(e) {

      console.log("fired");

      if (e) {
        this.selected = false
      }
      if (!e && !this.selected) {
        this.model.insuredName = this.enteredInsuredName;
        this.enteredInsuredName && this.formData(null, false)
      }
    },
    scrollUp() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.topSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#topSection" // required if updateHistory is true
      });
    },
    scrollDown() {
      //location.hash = "#calcSection";
      const myEl = this.$refs.calcSection;

      this.$smoothScroll({
        scrollTo: myEl,
        hash: "#calcSection" // required if updateHistory is true
      });
    },
    async createNewQuote() {

      var quoteToSend = {
        "brokerId": "brk-0134",
        "type": "light-machinery",
        "inceptionDate": this.model.policyStart,
        "expiryDate": this.model.expiryDate,
        "periodOfCover": 12,
        "insuredPostcode": this.model.insuredPostcode,
        "insuredState": this.model.insuredState,
        "insuredSuburb": this.model.insuredCity,
        "insuredName": this.model.insuredName,
        "excess": 1000,
        "registeredForGst": this.model.registeredForGST,
        "source": "YIHQ Form",
        "equipmentItems": this.selectEquipmentItems.map(m => {
          return {
            "itemId": m.categoryItemId,
            "specifiedSumInsured": parseFloat(m.insuredAmount),
            "unSpecifiedSumInsured": 0,
            "excessId": m.selectedExcessId
          }
        }),
        "customFields": {
          "customerId": this.model.selectedCustomerId,
          "claimsOrLossesLast3Years": false,
          "moreThan50k": false,
          "isChubbCurrentlyUnderWriting": false
        }
      }



      //       {
      //   "itemId": 266,
      //   "specifiedSumInsured": 15000,
      //   "unSpecifiedSumInsured": 0,
      //   "excessId": 30000
      // }

      // {
      //   "itemId": 266,
      //     "specifiedSumInsured": 12000,
      //       "unSpecifiedSumInsured": 12000,
      //         "excessId": 30000
      // }

      //console.log(this.lse)

      //var findEquipmentCode =


      console.log(this.model);

      console.log(quoteToSend)



      // const isValid = await this.$refs.formValidator.validate();

      // if (!isValid) {
      //   this.$toasted
      //     .error("Please complete the required fields before proceeding.", {
      //       position: "bottom-center"
      //     })
      //     .goAway(4000);
      // } else {
      //   var calcData = quoteFormMethods.getCalculation(this.model);



      //   this.$toasted
      //     .success("Quote Successfully Created", {
      //       position: "bottom-center"
      //     })
      //     .goAway(4000);

      //

      /*
      
            this.isLoading = true;
      
      
      
            protecsureFunctions.requestQuote(quoteToSend).then(resp => {
              console.log(resp);
              this.mode = "view";
      
      
              this.model.Customer_policy_insurance_total_premium =
                resp.totalPremium;
              this.model.Customer_policy_insurance_premium =
                resp.grossBasePremium;
              this.model.Customer_policy_insurance_premium_gst =
                resp.gst;
              this.model.Customer_policy_insurance_premium_stamp_duty =
                resp.stampDuty;
              //this.model.Customer_policy_fee = calcData.Customer_policy_fee;
      
              resp.equipmentExcesses.forEach(item => {
                this.quoteNotes.push(item.description)
              })
      
              resp.equipmentMaxLiability.forEach(item => {
                this.quoteNotes.push(item.description)
              })
      
      
              this.isLoading = false;
      
              this.model.Customer_policy_status = "in_progress";
            })
      
      
      
            //requestQuote
      */


      //console.log(this.selectedCustomerId);

      // var policy_id = await quoteFormMethods.createQuote(
      //   this.model,
      //   this.selectedCustomerId
      // );

      // this.$router.push({
      //   path: "quotes/" + policy_id,
      //   query: { status: "created" }
      // });
      //}
    },
    emailOffer() {
      // quoteFormMethods.changeStatus(
      //   this.policy_id,
      //   "offer_sent_awaiting_information"
      // );

      // GlobalStore.realmApp.functions
      //   .crud_customerPolicy("getCombined", {
      //     policy_id: parseInt(this.policy_id)
      //   })
      //   .then(resp => {
      //     emailMethods.sendOfferEmail(GlobalStore.realmApp, resp.data);
      //     this.$router.push("/quotes/" + this.policy_id + "/offerSent");
      //   });
    },
    goBack() {
      this.step = "step1";
    },
    editQuote() {
      this.formMode = "edit";
      this.scrollUp();
    },
    updateQuote() {
      var calcData = quoteFormMethods.getCalculation(this.model);

      this.model.Customer_policy_insurance_total_premium =
        calcData.Customer_policy_insurance_total_premium;
      this.model.Customer_policy_insurance_premium =
        calcData.Customer_policy_insurance_premium;
      this.model.Customer_policy_insurance_premium_gst =
        calcData.Customer_policy_insurance_premium_gst;
      this.model.Customer_policy_insurance_premium_stamp_duty =
        calcData.Customer_policy_insurance_premium_stamp_duty;
      this.model.Customer_policy_fee = calcData.Customer_policy_fee;

      quoteFormMethods.updateQuote(this.realmApp, this.rawModel, this.model);

      this.scrollDown();

      this.formMode = "view";
    },
    firstFormSubmit() {
      console.log("clicked");
    },
    readFinancier(event) {
      console.log("typed");
      if (event == "Other") {
        this.financierOtherDisabled = false;
        //this.model.financier = "";
      } else {
        this.financierOtherDisabled = true;
        this.model.financierOther = "";
      }
    },
    /**
     * @desc Clears the address city, state and postcode fields when the street
     * field is cleared.
     */
    clearAddressFields() {
      if (this.model.insuredStreet == "") {
        this.model.insuredCity = "";
        this.model.insuredState = "";
        this.model.insuredPostcode = "";
      }
    },
    initAddressSearch() {
      let script = document.createElement("script");
      script.setAttribute(
        "src",
        "https://api.addressfinder.io/assets/v3/widget.js"
      );
      script.setAttribute("async", true);
      script.onload = () => {
        this.widget = new window.AddressFinder.Widget(
          document.getElementById("addrs_1"),
          "NMY9RTVQ3UHADL76FJ8G",
          "AU",
          {
            address_params: {
              gnaf: 1
            }
          }
        );
        this.widget.on("result:select", (fullAddress, metaData) => {
          this.model.insuredAddress = metaData.address_line_1;
          this.model.Customer_contact_street = metaData.address_line_combined;
          this.model.Customer_contact_city = metaData.locality_name;
          this.model.Customer_state = metaData.state_territory;
          this.model.Customer_postcode = metaData.postcode;
        });
      };
      document.head.appendChild(script);
    }
  },
  async mounted() {

    this.model = this.editModel;

    //this.model.descriptionOfAsset = "";
    this.model.acceptDOD = null;

    if (this.model.cloudFloatStatus === "monthlyFlowApproved") {
      this.step = "accepted";
    }

    // this.model.security1 = [];

    // this.model.security1_other = "";
    // this.model.security2_other = "";
    // this.model.security4_other = "";



    this.mode = this.formMode;

    this.initAddressSearch();

    this.isLoading = true;

    console.log(this.model);

    
    protecsureFunctions.getFormInitData().then(resp => {

      //console.log(resp);

      this.formInitData = resp;

      console.log(resp);

      var eqItem = resp.equipmentCategories.find(f => f.categoryItemId == this.model.Quote_data.equipmentItems[0].itemId);

      console.log(eqItem);

      //.filter(f => f.excessValue >= eqItem.minimumExcessAllowed)

      this.excessOptions = resp.equipmentExcesses.filter(f => f.excessValue >= eqItem.minimumExcessAllowed).map(m => {
        var enabled = false;


        //if (m.excessValue >= eqItem.minimumExcessAllowed) {
        //enabled = true;
        //minExcess = m.excessValue;
        //minExcessId = m.excessId;
        //}
        return {
          label: m.excessValue,
          value: m.excessValue,
          //enabled: enabled,
          //selected: false
        }
        //} else {
        return null
        //}

      });


      console.log(this.excessOptions);
      this.isLoading = false;
      this.applyCloudfloatRetryFlow();
    });

    

    //this.$refs.formValidator.validate();

    //const _isValid = 
    setTimeout(() => {
      this.$refs.formValidator.validate();
    }, 2000);

    // this.isLoading = true;

    //this.model.totalSumInsured

    // await appFunctions.crud_customerLCPolicy("getCombinedByRealmId", {
    //   Realm_user_id: GlobalStore.brokerObj.Realm_user_id
    // })
    //   .then(resp => {
    //     this.customerList = resp.data.filter(data => data && data.Customer_insured_name)
    //   });


    // this.fieldsDisabled.businessDesc = false;
    // this.fieldsDisabled.contactEmail = false;
    // this.fieldsDisabled.contactPhone = false;
    // this.fieldsDisabled.insuredStreet = false;
    // this.fieldsDisabled.insuredCity = false;
    // this.fieldsDisabled.insuredState = false;
    // this.fieldsDisabled.insuredPostcode = false;
    // //this.fieldsDisabled.insuredName = true;
    // this.fieldsDisabled.insuredABN = false;
    // this.fieldsDisabled.contactFName = false;
    // this.fieldsDisabled.contactLName = false;

    // this.fieldsDisabled.policyStart = false;
    // this.fieldsDisabled.expiryDate = false;

    // this.fieldsDisabled.insuredName = false;



    // protecsureFunctions.getFormInitData().then(resp => {
    //   console.log(resp);

    //   this.formInitData = resp;

    //   this.model.policyStart = resp.periodOfCover[0].inceptionDate;
    //   this.model.expiryDate = resp.periodOfCover[0].expiryDate;

    //   this.model.registeredForGST = true;

    //   this.model.claimsOrLossesLast3Years = false;
    //   this.model.moreThan50k = false;



    //   this.isLoading = false;

    // });





    // this.formMode = this.mode;
    // this.realmApp = GlobalStore.realmApp;

    // this.policy_id = this.$route.params.id;

    // this.selectedCustomerId = 0;

    // //changeStatus();

    // let script = document.createElement("script");
    // script.setAttribute(
    //   "src",
    //   "https://api.addressfinder.io/assets/v3/widget.js"
    // );
    // script.setAttribute("async", true);
    // script.onload = () => {
    //   this.widget = new window.AddressFinder.Widget(
    //     document.getElementById("addrs_1"),
    //     "NMY9RTVQ3UHADL76FJ8G",
    //     "AU",
    //     {
    //       address_params: {
    //         gnaf: 1
    //       }
    //     }
    //   );
    //   this.widget.on("result:select", (fullAddress, metaData) => {
    //     this.model.insuredAddress = metaData.address_line_1;
    //     this.model.insuredStreet = metaData.address_line_1;
    //     this.model.insuredCity = metaData.locality_name;
    //     this.model.insuredState = metaData.state_territory;
    //     this.model.insuredPostcode = metaData.postcode;
    //   });
    // };
    // document.head.appendChild(script);

    // console.log(this.$route.params.status);

    // if (this.$route.query.status) {
    //   this.scrollDown();
    // }
    //this.mode = "view";

    //this.model.Customer_policy_status = "in_progress";
  },
  components: {
    BaseInput,
    [Select.name]: Select,
    [Option.name]: Option,
    Spinner,
    FileUpload,
    VueMultiselectComponent,
    ButtonRadioGroup
  },
  directives: {
    /**
     * Used ensure the keyboard is shown on mobile devices when clicking on an el-select.
     * This is because element-ui was not designed for mobile:
     * https://github.com/ElemeFE/element/issues/12742#issuecomment-420866658
     */
    cancelReadOnly(el) {
      const input = el.querySelector(".el-input__inner");
      input.removeAttribute("readonly");
    }
  }
};
</script>
<style>
.vue2-value-item {
  margin-left: 10px !important;


}

.vue2-value-item-text {
  min-width: 100px;
  padding-left: 10px;
}

.abn-link {
  font-size: 9pt;
  color: var(--uBind) !important;
  position: absolute;
  right: 0px;
  margin-right: 10px;
}

.eq-selected {
  border: 2px black solid !important;
}

.infoText {
  font-size: 0.875rem;
  margin-bottom: 20px;
}

.answerText {
  font-size: 0.875rem;
  font-weight: 600;
  margin-bottom: 30px;
}

.duty-disclosure-required-panel {
  border: 4px solid red;
  border-radius: 8px;
  padding: 12px 24px 4px 12px;
}

.duty-disclosure-required-panel .form-group {
  margin-bottom: 0;
}

.duty-disclosure-select {
  margin-right: 16px;
}

.duty-disclosure-required-panel .invalid-feedback {
  display: block;
  width: calc(100% - 16px);
}

.payment-terms-heading {
  margin-bottom: 8px;
}

.payment-terms-helper {
  margin-bottom: 32px;
}

.uBind .row div.payment-terms-retry-notice:first-child {
  max-width: 980px;
  margin: 0 auto 24px;
  padding: 16px 24px;
  box-sizing: border-box;
  border: 1px solid #f0c36d;
  border-radius: 8px;
  background: #fff8e8;
  color: #5c4a1f;
  text-align: left;
  line-height: 1.5;
}

.payment-terms-panel {
  border: 1px solid var(--uBind);
  border-radius: 10px;
  margin: 62px auto 30px;
  max-width: 980px;
  min-height: 260px;
  padding: 48px 48px 40px;
  position: relative;
}

.cloudfloat-logo {
  display: block;
  height: auto;
  margin: 0 auto;
  max-width: 180px;
  width: 100%;
}

.cloudfloat-quote {
  margin: 0 auto;
  max-width: 560px;
  padding: 8px 16px 16px;
}

.cloudfloat-brand {
  margin-bottom: 28px;
  text-align: center;
}

.cloudfloat-powered-by {
  color: #8a94a6;
  font-size: 11pt;
  font-weight: 400;
  margin-bottom: 8px;
}

.cloudfloat-card {
  background: #fff;
  margin-bottom: 28px;
  padding: 40px;
}

.cloudfloat-divider {
  border-top: 1px solid #e4e7eb;
  margin: 18px 0;
}

.cloudfloat-summary-row {
  align-items: center;
  color: #1f2937;
  display: flex;
  font-size: 12pt;
  justify-content: space-between;
}

.cloudfloat-summary-row span {
  padding-right: 20px;
}

.cloudfloat-summary-row strong {
  font-size: 12pt;
  font-weight: 500;
  white-space: nowrap;
}

.cloudfloat-summary-row--total {
  margin-top: 14px;
}

.cloudfloat-schedule {
  padding: 4px 0;
}

.cloudfloat-schedule-item {
  align-items: flex-start;
  display: flex;
  gap: 16px;
}

.cloudfloat-schedule-track {
  align-items: center;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: 34px;
}

.cloudfloat-step {
  align-items: center;
  border-radius: 50%;
  display: inline-flex;
  flex-shrink: 0;
  font-size: 11pt;
  font-weight: 600;
  height: 34px;
  justify-content: center;
  line-height: 1;
  width: 34px;
}

.cloudfloat-step--active {
  background: #111;
  color: #fff;
}

.cloudfloat-step--final {
  background: #eef1f4;
  color: #667085;
}

.cloudfloat-step-line {
  background: #d0d5dd;
  flex: 1;
  margin: 6px 0;
  width: 2px;
}

.cloudfloat-step-dots {
  align-items: center;
  display: flex;
  flex-direction: column;
  gap: 4px;
  height: 34px;
  justify-content: center;
}

.cloudfloat-step-dots span {
  background: #98a2b3;
  border-radius: 50%;
  display: block;
  height: 4px;
  width: 4px;
}

.cloudfloat-schedule-content {
  align-items: center;
  display: flex;
  flex: 1;
  justify-content: space-between;
  min-height: 34px;
  padding-bottom: 18px;
  padding-top: 0;
}

.cloudfloat-schedule-item--last .cloudfloat-schedule-content {
  padding-bottom: 0;
}

.cloudfloat-schedule-label {
  color: #344054;
  font-size: 12pt;
  font-weight: 400;
}

.cloudfloat-schedule-amount {
  color: #111;
  font-size: 12pt;
  font-weight: 500;
  white-space: nowrap;
}

.cloudfloat-cta-button {
  background: #ff5a44 !important;
  border: none !important;
  border-radius: 999px !important;
  box-shadow: none !important;
  display: block;
  font-size: 12pt;
  font-weight: 700;
  margin: 0 auto 0;
  max-width: 560px;
  padding: 14px 28px !important;
  width: 100%;
}

.cloudfloat-cta-button:hover,
.cloudfloat-cta-button:focus,
.cloudfloat-cta-button:active {
  background: #e84d38 !important;
}

.cloudfloat-loading-inline {
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 140px;
  padding: 10px 20px 20px;
}

.cloudfloat-orbit-spinner,
.cloudfloat-orbit-spinner * {
  box-sizing: border-box;
}

.cloudfloat-orbit-spinner {
  height: 55px;
  margin: 0 auto 16px;
  perspective: 800px;
  position: relative;
  width: 55px;
}

.cloudfloat-orbit-spinner .orbit {
  border-radius: 50%;
  box-sizing: border-box;
  height: 100%;
  position: absolute;
  width: 100%;
}

.cloudfloat-orbit-spinner .orbit:nth-child(1) {
  animation: cloudfloat-orbit-one 1200ms linear infinite;
  border-bottom: 3px solid var(--uBind);
  left: 0;
  top: 0;
}

.cloudfloat-orbit-spinner .orbit:nth-child(2) {
  animation: cloudfloat-orbit-two 1200ms linear infinite;
  border-right: 3px solid var(--uBind);
  right: 0;
  top: 0;
}

.cloudfloat-orbit-spinner .orbit:nth-child(3) {
  animation: cloudfloat-orbit-three 1200ms linear infinite;
  border-top: 3px solid var(--uBind);
  bottom: 0;
  right: 0;
}

@keyframes cloudfloat-orbit-one {
  0% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(-45deg) rotateZ(360deg);
  }
}

@keyframes cloudfloat-orbit-two {
  0% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(50deg) rotateY(10deg) rotateZ(360deg);
  }
}

@keyframes cloudfloat-orbit-three {
  0% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(0deg);
  }
  100% {
    transform: rotateX(35deg) rotateY(55deg) rotateZ(360deg);
  }
}

.payment-terms-load-error {
  color: #cc1a1a;
  font-weight: 600;
  margin: 40px auto;
  max-width: 520px;
  text-align: center;
}

.payment-terms-toggle {
  background-color: white;
  left: 50%;
  padding: 0 4px;
  position: absolute;
  top: -24px;
  transform: translateX(-50%);
  z-index: 1;
  height: 0px;
}

.payment-terms-toggle.btn-group-toggle {
  display: inline-flex !important;
  flex-direction: row;
  white-space: nowrap;
}

.payment-term-button {
  align-items: center;
  display: inline-flex;
  flex: 0 0 auto;
  font-size: 14pt;
  font-weight: 700;
  justify-content: center;
  min-height: 43px;
  min-width: 310px;
  padding: 0 28px;
}

.payment-terms-placeholder {
  text-align: center;
  color: #111;
  font-size: 12pt;
  font-weight: 300;
  line-height: 1.35;
  margin: auto;
  padding-bottom: 20px;
  width: 100%;
  max-width: 700px;
}

.payment-terms-loading-text {
  color: var(--uBind);
  font-weight: 700;
  margin: 0;
}

.payment-terms-monthly-panel {
  min-height: 180px;
  padding: 12px 8px 8px;
}

.payment-terms-actions {
  margin-top: 20px;
}
</style>
